// Generated by Melange

import * as Atdgen_codec_decode from "melange-atdgen-codec-runtime/atdgen_codec_decode.js";
import * as Atdgen_codec_encode from "melange-atdgen-codec-runtime/atdgen_codec_encode.js";
import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_MapString from "melange.belt/belt_MapString.js";
import * as Caml_exceptions from "melange.js/caml_exceptions.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Json__Json_decode from "melange-json/Json_decode.js";

const DataFormat_error = /* @__PURE__ */Caml_exceptions.create("Buhta_models.Validation.DataFormat_error");

const read_error_data = Atdgen_codec_decode.make(function (json) {
      const obj = Js__Js_json.classify(json);
      if (typeof obj === "number") {
        throw new Caml_js_exceptions.MelangeError(DataFormat_error, {
                  MEL_EXN_ID: DataFormat_error,
                  _1: "Couldn't parse validation errors data"
                });
      }
      if (obj.TAG === /* JSONObject */2) {
        const obj$1 = obj._0;
        const keys = Belt__Belt_List.fromArray(Object.keys(obj$1));
        return Belt__Belt_List.reduce(keys, undefined, (function (fieldsMap, key) {
                      const jsonVal = obj$1[key];
                      return Belt__Belt_MapString.set(fieldsMap, key, Json__Json_decode.string(jsonVal));
                    }));
      }
      throw new Caml_js_exceptions.MelangeError(DataFormat_error, {
                MEL_EXN_ID: DataFormat_error,
                _1: "Couldn't parse validation errors data"
              });
    });

const write_error_data = Atdgen_codec_encode.make(function (data) {
      return Belt__Belt_MapString.reduce(data, {}, (function (dict, key, err) {
                    dict[key] = err;
                    return dict;
                  }));
    });

export {
  DataFormat_error ,
  read_error_data ,
  write_error_data ,
}
/* read_error_data Not a pure module */
